module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "muf-field",
    class: {
      'muf-field--error': _vm.hasError
    }
  }, [(_vm.label) ? _c('label', {
    staticClass: "muf-label",
    attrs: {
      "for": _vm.inputId
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label)), (_vm.required) ? _c('span', {
    staticClass: "muf-required"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "muf-dropzone",
    attrs: {
      "for": _vm.inputId
    }
  }, [_c('span', {
    staticClass: "muf-icon"
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "17 8 12 3 7 8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "3",
      "x2": "12",
      "y2": "15"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "muf-copy"
  }, [_c('span', {
    staticClass: "muf-title"
  }, [_vm._v(_vm._s(_vm.displayTitle))]), _vm._v(" "), _c('span', {
    staticClass: "muf-subtitle"
  }, [_vm._v(_vm._s(_vm.displaySubtitle))])]), _vm._v(" "), _c('span', {
    staticClass: "muf-action"
  }, [_vm._v(_vm._s(_vm.uploading ? 'Uploading...' : 'Choose'))]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticClass: "muf-input",
    attrs: {
      "type": "file",
      "id": _vm.inputId,
      "name": _vm.name,
      "accept": _vm.accept,
      "required": _vm.required,
      "disabled": _vm.uploading
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _vm._v(" "), (_vm.uploading) ? _c('div', {
    staticClass: "muf-progress"
  }, [_c('div', {
    staticClass: "muf-progress-bar"
  })]) : _vm._e(), _vm._v(" "), (_vm.hasError) ? _c('span', {
    staticClass: "muf-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c82df35"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/ModernUploadField.vue
// module id = 1735
// module chunks = 2